import { render, staticRenderFns } from "./PopUpGeneratedReports.vue?vue&type=template&id=4c6cfa4a&"
import script from "./PopUpGeneratedReports.vue?vue&type=script&lang=ts&"
export * from "./PopUpGeneratedReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports